import React, { useState, useEffect } from 'react'
import Button from '../../atoms/Button/Button'
import FormCheckbox from '../../atoms/FormCheckbox/FormCheckbox'
import Link from 'next/link'
import { Trans } from '../../atoms'
import useTrans from '../../../hooks/useTrans'
import { trackingGAEvent } from '../../../utils/gtm'
import { isBrandLayout } from '../../../utils/brand'

//Padre con array innestato che controlla l'includes
const NewCategorieListing = ({ categorie_list, current, categorie, HandleRouting }) => {
  const t = useTrans()
  const [nItems, setNItems] = useState(10)

  // copia di categorie_list con la categoria active in top
  const [activeOnTopList, setActiveOnTopList] = useState()

  useEffect(() => {
    let tmp = JSON.parse(JSON.stringify(categorie_list))
    const activeIndex = categorie_list.findIndex((element) => {
      if (element.id === categorie[0]) {
        return true
      } else {
        if (element.children.findIndex((child) => child.id === categorie[0]) !== -1) {
          return true
        } else {
          return false
        }
      }
    })
    if (activeIndex !== -1) {
      tmp.splice(activeIndex, 1)
      const activeCategoria = categorie_list[activeIndex]
      tmp.unshift(activeCategoria)
      if (activeCategoria.isolated_listing) {
        tmp = [tmp[0]]
      }
    }
    setActiveOnTopList(tmp)
  }, [categorie_list, categorie])

  const CheckIsActive = (item) => {
    let isActive = false
    categorie.find((element) => element == item.id) && (isActive = true)
    return isActive
  }

  const CheckIsChildrenActive = (item) => {
    let isActive = false
    item.children?.length > 0 &&
      item.children.forEach((element) => {
        !isActive && (isActive = CheckIsActive(element))
      })
    return isActive
  }

  function handleChange(active, item, categoria) {
    HandleRouting(active, item)
    if (!active)
      trackingGAEvent('filter_on_listing_sidebar', categoria?.nome || '', item?.nome || '')
  }

  return (
    <div className="categorie-listing">
      <p className="categorie-listing__title">
        <Trans chiave="CATEGORIE" />{' '}
      </p>
      <div className="categorie-listing__content">
        {activeOnTopList &&
          activeOnTopList.slice(0, nItems).map(
            (categoria) =>
              categoria.children.length > 0 && (
                <div key={categoria.nome}>
                  {CheckIsActive(categoria) || CheckIsChildrenActive(categoria) ? (
                    isBrandLayout(categoria) ? ( // item con link
                      <Link href={categoria.url} scroll={false}>
                        <a className={
                          `categorie-listing__item categorie-listing__item--selected` +
                          (CheckIsActive(categoria)
                            ? ' categorie-listing__item--selected-leaf'
                            : '')
                        }>
                          <p className={`categorie-listing__item`}>
                            {categoria.nome}
                          </p>
                        </a>
                      </Link>
                    ) : ( // item senza link
                      <p
                        className={
                          `categorie-listing__item categorie-listing__item--selected` +
                          (CheckIsActive(categoria)
                            ? ' categorie-listing__item--selected-leaf'
                            : '')
                        }
                      >
                        {categoria.nome}{' '}
                        {!isBrandLayout(categoria) ? (
                          <span>({categoria.numero_prodotti})</span>
                        ) : null}
                      </p>
                    )
                  ) : (
                    <Link href={categoria.url} scroll={false}>
                      <a className='categorie-listing__item__child-link'>
                        <p className={`categorie-listing__item`}>
                          {categoria.nome}{' '}
                          {!isBrandLayout(categoria) ? (
                            <span>({categoria.numero_prodotti})</span>
                          ) : null}
                        </p>
                      </a>
                    </Link>
                  )}

                  {(CheckIsActive(categoria) || CheckIsChildrenActive(categoria)) &&
                    categoria.children.map((child) =>
                      isBrandLayout(categoria) ? (
                        <Link href={child.url} scroll={false}>
                          <a className='categorie-listing__item__child-link'>
                            <p
                              className={`categorie-listing__item__child ${
                                CheckIsActive(child) && 'categorie-listing__item__child--selected'
                              }`}
                            >
                              {child.nome} <span>({child.numero_prodotti})</span>
                            </p>
                          </a>
                        </Link>
                      ) : (
                        child.numero_prodotti > 0 && (
                          <div
                            className={`categorie-listing__item__child ${
                              CheckIsActive(child) &&
                              'categorie-listing__item--selected categorie-listing__item--selected-leaf'
                            }`}
                          >
                            <FormCheckbox
                              size="sm"
                              checked={CheckIsActive(child)}
                              label={
                                <span className="categorie-listing__item__child__label">
                                  {child.nome} <span>({child.numero_prodotti})</span>
                                </span>
                              }
                              onChange={(e) => handleChange(CheckIsActive(child), child, categoria)}
                            />
                          </div>
                        )
                      )
                    )}
                </div>
              )
          )}
      </div>
      {categorie_list.length > nItems && !isBrandLayout(activeOnTopList?.[0]) && (
        <Button
          onClick={() => setNItems(categorie_list.length)}
          label={t('Mostra più Categorie')}
          variant="ghost"
          size="medium"
          className="categorie-listing__more"
        />
      )}
    </div>
  )
}

export default NewCategorieListing
